// extracted by mini-css-extract-plugin
module.exports = {"loading-wrap":"style_loading-wrap__3YE4g","page-loading":"style_page-loading__cA5WI","load":"style_load__qELFz"};